import { createThemeStore, FAMILY_THEME_CONFIG, type ThemeConfig } from "@jkast90/kast-common/theme";

// The sign-in site has no theme setting, so nothing ever writes this key and
// the store always follows the OS, live.
export const themeConfig: ThemeConfig = { storageKey: "kast-login-theme", ...FAMILY_THEME_CONFIG };
export const themeStore = createThemeStore(themeConfig);
